import CIcon from '@coreui/icons-react'
import { cilArrowRight, cilCheckCircle, cilHistory } from '@coreui/icons'
import { Link } from 'react-router-dom'
import type { AuditEvent } from '../../api/types'
import { formatDateTime } from '../../utils/format'
import { EmptyState } from '../common/AsyncState'

export function LedgerTimeline({
  events,
  compact = false,
}: {
  events: AuditEvent[]
  compact?: boolean
}) {
  if (!events.length)
    return (
      <EmptyState
        title="No published events yet"
        description="Approved public records will appear here in chronological order."
      />
    )
  return (
    <div className={`ledger-timeline ${compact ? 'ledger-timeline--compact' : ''}`}>
      {events.map((event) => (
        <article key={event.eventId} className="ledger-event">
          <div className="ledger-event__rail">
            <span>
              <CIcon icon={event.category === 'correction' ? cilHistory : cilCheckCircle} />
            </span>
          </div>
          <div className="ledger-event__body">
            <div className="ledger-event__meta">
              <span className={`category category-${event.category}`}>{event.category}</span>
              <time>{formatDateTime(event.occurredAt)}</time>
            </div>
            <h3>{event.title}</h3>
            <p>{event.summary}</p>
            <div className="ledger-event__footer">
              <code>{event.eventId}</code>
              {event.projectAlias && <span>{event.projectAlias}</span>}
              <Link to={`/ledger/${event.eventId}`}>
                View record <CIcon icon={cilArrowRight} />
              </Link>
            </div>
          </div>
        </article>
      ))}
    </div>
  )
}
